import React from "react";

const MoreIcon = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_299_963)">
      <circle cx="2.5" cy="8" r="1.75" fill="white" />
      <circle cx="8" cy="8" r="1.75" fill="white" />
      <circle cx="13.5" cy="8" r="1.75" fill="white" />
    </g>
    <defs>
      <clipPath id="clip0_299_963">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default MoreIcon;
